import Layers from "@/constants/layers";
import store from "@/store";
import CommonGetters from "@/store/common/common-getters";

const TOOL_LAYERS_MAP = {
    ovt: Layers.OVT,
    sovt: Layers.SOVT,
    fvt: Layers.FVT,
    scd: Layers.SCD,
};

const LayerService = {
    getTool() {
        return store.getters[CommonGetters.tool];
    },

    getToolLayers(tool = LayerService.getTool()) {
        return TOOL_LAYERS_MAP[tool] || Layers.VIS;
    },
};

export default LayerService;
